import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'h3-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoadingOverlayComponent {
  @Input({ required: true }) show!: boolean | null;
  @Input() translucent = false;

  backgroundColor() {
    return `rgba(255, 255, 255, ${this.translucent ? 0.3 : 1})`;
  }
}
